// extracted by mini-css-extract-plugin
export var askAiIcon = "_oz-9";
export var container = "_oz-0";
export var groupSeparator = "_oz-a";
export var highlight = "_oz-4";
export var resultIcon = "_oz-5";
export var resultItem = "_oz-7";
export var resultSubtitle = "_oz-3";
export var resultTitle = "_oz-2";
export var resultsList = "_oz-1";
export var searchGroup = "_oz-6";
export var selected = "_oz-8";